// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"qQ-z","inlineTitle":"rQ-z","sponsoredAdsWrapper":"sQ-z","marketplaceRecosWrapper":"tQ-z"};